import { createGlobalStyle } from 'styled-components'


export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    @media(max-width: 1120px){
      font-size: 93.75%;
    }

    @media(max-width: 720px){
      font-size: 87.5%;
    }
  }

  body {
    scrollbar-width: thin;
    scrollbar-color: blue orange; 
  }

  body, button, input, textarea {
    font-family: "Inter", sans-serif;
  }

  button {
    cursor: pointer;
  }

  [disabled]{
    cursor: not-allowed;
    opacity: 0.6;
  }
`